export const setRequestStatus = "editor/requestStatus/SET";
export const clearRequestStatus = "editor/requestStatus/CLEAR";
